import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import BottomTabBar from './BottomTabBar';
import CreatePostModal from '@/components/feed/CreatePostModal';
import InstallPWA from '@/components/InstallPWA';

export default function AppLayout({ children, hideSidebar, hideTopBar, onPostCreated }) {
  const { isAuthenticated } = useAuth();
  const [showCreatePost, setShowCreatePost] = useState(false);

  if (!isAuthenticated && hideSidebar) {
    return (
      <div className="min-h-screen bg-white">
        {!hideTopBar && <TopBar />}
        {children}
        <InstallPWA />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex bg-[#F8FAFC]">
      {isAuthenticated && <Sidebar onCreatePost={() => setShowCreatePost(true)} />}
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar />
        <main className="flex-1 pb-16 lg:pb-0">
          {typeof children === 'function' ? children({ openCreatePost: () => setShowCreatePost(true), onPostCreated }) : children}
        </main>
      </div>
      {isAuthenticated && <BottomTabBar onCreatePost={() => setShowCreatePost(true)} />}
      <CreatePostModal open={showCreatePost} onClose={() => setShowCreatePost(false)} onPostCreated={onPostCreated || (() => {})} />
      <InstallPWA />
    </div>
  );
}
